import React from "react";

function Tab({ label, render, className }) {
  const Component = render;
  return <Component label={label} className={className} />;
}

export default Tab;
